import dayjs from "dayjs";

import {
  DEFAULT_REPORTING_RANGE_DAYS,
  MAX_REPORTING_RANGE_DAYS,
} from "./dto";

/** Plage inclusive par défaut : 30 derniers jours (guide §7.3). */
export const defaultReportingRange = (): { from: string; to: string } => {
  const to = dayjs();
  return {
    from: to.subtract(DEFAULT_REPORTING_RANGE_DAYS - 1, "day").format("YYYY-MM-DD"),
    to: to.format("YYYY-MM-DD"),
  };
};

/** Borne la plage à 400 jours et inverse from/to si besoin. */
export const clampReportingRange = (
  from: string,
  to: string
): { from: string; to: string } => {
  const start = dayjs(from);
  const end = dayjs(to);
  if (!start.isValid() || !end.isValid()) return defaultReportingRange();
  const [lo, hi] = start.isAfter(end) ? [end, start] : [start, end];
  if (hi.diff(lo, "day") > MAX_REPORTING_RANGE_DAYS - 1) {
    return {
      from: hi
        .subtract(MAX_REPORTING_RANGE_DAYS - 1, "day")
        .format("YYYY-MM-DD"),
      to: hi.format("YYYY-MM-DD"),
    };
  }
  return { from: lo.format("YYYY-MM-DD"), to: hi.format("YYYY-MM-DD") };
};
